import React from "react";
import "./Footer.css";

// Import the trust seal image from the correct path
import trustSealImage from "../assets/Trustseal/trustseal.jpg";  // Adjust the path if necessary

const Footer = () => {
  const socialLinks = [
    { 
      id: 1, 
      title: "اینستاگرام", 
      link: "https://instagram.com/khanehyeghtesad",
      icon: (
        <svg className="social-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
        </svg>
      )
    },
    { 
      id: 2, 
      title: "توییتر", 
      link: "https://x.com/khanehyeghtesad",
      icon: (
        <svg className="social-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
        </svg>
      )
    },
    { 
      id: 3, 
      title: "تلگرام", 
      link: "https://t.me/khanehyeghtesad",
      icon: (
        <svg className="social-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21.67 3.87L2.9 10.71c-1.48.54-1.48 2.04 0 2.58l4.72 1.73L17.81 7c.37-.34.88.11.54.45L9.39 16.32v3.38c0 1.42 1.72 2.04 2.71 1.05l2.61-2.61 5.14 3.78c1.12.83 2.71.07 2.99-1.43l3.11-16.06c.31-1.64-1.52-2.98-3.01-2.2z"/>
        </svg>
      )
    },
  ];

  return (
    <footer id="footer" className="footer">
      <div className="footer-container">
        {/* About Us */}
        <div className="footer-section about-us">
          <h3 className="footer-title">درباره ما</h3>
          <h2 className="footer-logo">
            <span className="logo-bold">خانه </span>اقتصاد<span className="logo-dot"></span>
          </h2>
          <p>
            «خانه اقتصاد» چتر رسانه‌ای برای پوشش تمام تحولات اقتصادی و واکاوی سیاست گذاری‌های اقتصاد کشور برای آشکار ساختن مسیر رشد و توسعه اقتصاد ایران است. ما سعی داریم بدون تعارفات معمول رسانه‌ای، صریح و بی‌پرده دغدغه‌ها و معضلات اقتصادی عموم جامعه را بیان کنیم و با مطالبه گری آن‌ها از دستگاه‌های مسئول سعی در حل این مشکلات داشته باشیم.
          </p>
          <p>مدیر مسئول پایگاه خبری-تحلیلی خانه اقتصاد: مهدی مهرپور</p>
          <p>شماره تماس خانه اقتصاد: <a href="tel:+989912159716" className="phone-number">۰۹۹۱۲۱۵۹۷۱۶</a></p>
        </div>
        
        {/* Social Networks */}
        <div className="footer-section politics">
          <h3 className="footer-title">شبکه‌های اجتماعی</h3>
          <div className="social-links">
            {socialLinks.map((social) => (
              <a 
                key={social.id} 
                href={social.link} 
                className="social-link"
                target="_blank" 
                rel="noopener noreferrer"
              >
                {social.icon}
                <span>{social.title}</span>
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© Copyright khanehyeghtesad. All Rights Reserved.</p>
      </div>

      {/* Trustseal with local image - clickable */}
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "150px", overflow: "visible" }}>
        <a href="https://e-rasaneh.ir/Certificate/96685" target="_blank" rel="noopener noreferrer">
          <img 
            src={trustSealImage} 
            alt="E-Rasaneh Trust Seal" 
            style={{ 
              maxWidth: "200px",  // Set a max width for the image
              width: "100%",  // Make the image responsive (100% of container width)
              height: "auto",  // Maintain aspect ratio
              objectFit: "contain", // Ensure the image scales properly
              paddingTop: "20px"
            }} 
          />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
